import React, { useState, useContext, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WithdrowItem from "./Component/WithdrowItem";
// import { ArrowRightShort, ExclamationCircle } from "react-bootstrap-icons";
import { isMobile } from "react-device-detect";
import ApiUserWithdrawal from "../../../core/api/api.userWithdrawal";
import ContextApp from "../../../core/contexts/context.app";
import { Zoom } from "react-awesome-reveal";
// import { RotateCircleLoading } from "react-loadingg";
import _ from "lodash";
import {
  IconArrowRight,
  IconError,
  IconErrorCircle,
  IconNotFound,
} from "../../../assets/icons";
import DottedLoadingData from "../../components/DottedLoadingData";
function WithdrowList() {
  const [liveData, setLiveData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const ctx = useContext(ContextApp);
  const navigate = useNavigate();

  useEffect(() => {
    if (ctx.isAuth) {
      getData();
    } else {
      navigate("/login");
    }
  }, [ctx.isAuth]);

  async function getData() {
    try {
      // گرفتن درخواست های برگشت پول
      const response = await ApiUserWithdrawal.getAllUserWithdrawal();
      setIsLoading(false);
      if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
        setLiveData(response.data);
      }
    } catch (error) {}
  }

  return (
    <Container
      fluid
      className={
        isMobile
          ? "px-0 main-content min-height-page"
          : " main-content  min-height-page px-0"
      }
    >
      {!isMobile ? (
        <Container fluid className="px-0 bg-light-3">
          <Container>
            <Row className="py-3 fs-085">
              <Col xs={12} className="pe-0">
                <Link to="/" className="text-muted">
                  {" "}
                  صفحه اصلی{" "}
                </Link>{" "}
                /{" "}
                <Link to="/profile" className="text-muted">
                  {" "}
                  پروفایل{" "}
                </Link>{" "}
                /{" "}
                <Link to="/withdrow" className="text-muted font-weight-bold">
                  {" "}
                  درخواست های برداشت{" "}
                </Link>
              </Col>
            </Row>
          </Container>
        </Container>
      ) : (
        <Container fluid className="bg-light-1 pt-3 pb-2 fs-07">
          <Row>
            <Col xs={12} className="my-auto text-right ">
              <Link to="/" className="text-secondary d-inline-block">
                صفحه اصلی
              </Link>
              <span className="px-1 d-inline-block text-secondary">/</span>

              <Link to="/wallet" className="text-secondary  d-inline-block">
                کیف پول
              </Link>
              <span className="px-1 d-inline-block text-secondary">/</span>

              <div className="text-secondary d-inline-block">
                درخواست های برداشت
              </div>
            </Col>
          </Row>
        </Container>
      )}
      <Container className="">
        {isLoading ? (
          <div className="mt-3">
            <DottedLoadingData withText="false" />
          </div>
        ) : liveData && liveData.length > 0 && liveData !== undefined ? (
          <Row>
            {liveData?.map((itemData, index) => (
              <WithdrowItem
                key={index}
                ItemPrice={itemData.rialAmount}
                ItemDate={itemData.paymentDate}
                ItemDescription={itemData.statusDesc}
                ItemCode={itemData.trackingCode}
                ItemStatus={itemData.statusS}
                ItemStatusType={itemData.status === 4 ? false : true}
                fullName={itemData.destinationAccountAccountOwnerName}
                bankName={itemData.destinationAccountBank}
                accountInfo={itemData.destinationAccountCardNumber}
              />
            ))}
          </Row>
        ) : (
          <Row className=" pt-xl-0 pt-md-0 transaction-box xl-svg">
            {/* <ExclamationCircle
                  style={{ color: "#c8c8c8" }}
                  size={130}
                  className="my-3 text-center"
                /> */}
            <div className="full-width text-center px-3 mt-5">
              <IconNotFound fillColor="#b1b1b1" />
              <div class="pb-5 pt-5 text-center col">
                <div class="fs-103  fw-bold">
                  {" "}
                  اطلاعاتی جهت نمایش یافت نشد !
                </div>
                <div class="mt-3 fs-101 text-black-06">
                  درخواست برداشت ثبت نشده است.
                </div>
              </div>
            </div>
          </Row>
        )}
      </Container>
    </Container>
  );
}
export default WithdrowList;
